import { render, staticRenderFns } from "./ModalCriarRepresentante.vue?vue&type=template&id=1e6bc028&"
import script from "./ModalCriarRepresentante.vue?vue&type=script&lang=js&"
export * from "./ModalCriarRepresentante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports